import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoader from '../../../../../../components/PageLoader';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectMembershipsListItems } from '../../../../../../redux/memberships/selector';
import { selectMembershipTypesListItems } from '../../../../../../redux/membership-types/selector';
import MembershipMemberMappingComponent from '../components/membership-member-mapping.component';
import { membershipMemberMappings } from '../../../../../../redux/membership-member-mappings/action';
import { membershipTypes } from '../../../../../../redux/membership-types/action';
import { memberships } from '../../../../../../redux/memberships/action';
import { users } from '../../../../../../redux/users/action';
import { selectUsersListItems } from '../../../../../../redux/users/selector';
import { selectMembershipMemberMappingsQueryItems } from '../../../../../../redux/membership-member-mappings/selector';


const ManagementMembershipMemberMapping = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryData = useSelector(selectMembershipMemberMappingsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const membershipItems = useSelector(selectMembershipsListItems)
const userItems = useSelector(selectUsersListItems)
const [
    selectedMembershipMemberMappings,
    setSelectedMembershipMemberMappings
  ] = useState<any>([])
  const membershipTypeItems = useSelector(selectMembershipTypesListItems)
  const fetchMembershipTypeById= ()=>{
    dispatch(membershipMemberMappings.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-member-mappings/query`,entity:'membershipMemberMappings',jsonData:{
          
    Records: [
      { 
              "Id": parmas?.id
          
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
 
})
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedMembershipMemberMappings({ ...selectedMembershipMemberMappings, [field]: event });
  }

  useEffect(
    () => {
        dispatch(membershipTypes.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types/list`,entity:'membershipTypes',jsonData:{}
           }))
           .then(()=>{
            dispatch(memberships.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships/list`,
                entity: 'memberships',
                jsonData: {}
            }))
          }).then(()=>{
            dispatch(users.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/iam/users/list`,entity:'users',jsonData:{
          
        }}))
          })
    .then(()=>{
      if (parmas?.id > 0) {
        fetchMembershipTypeById()
        setIsLoading(false)
      }else {
        setIsLoading(false)
      }
     
    })
    
     
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedMembershipMemberMappings(queryData?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    
    if (parmas?.id > 0) {
    
     dispatch(membershipMemberMappings.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-member-mappings`,entity:'membershipMemberMappings',jsonData:{
          
    Records: [
        selectedMembershipMemberMappings
    ]
 
}})).then(()=>{
  back()
})

    }else{
      dispatch(membershipMemberMappings.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-member-mappings`,entity:'membershipMemberMappings',jsonData:{
          
      Records: [    
        selectedMembershipMemberMappings
      ]
    
  }})).then(()=>{
    back()
  })
    }
   
   
  }

const back=()=>{
  navigate('/management/organization/membership-management/membership-member-mappings')
} 

    return (
    <>

    {isLoading ? <PageLoader /> : 
         <MembershipMemberMappingComponent 
         membershipType={membershipTypeItems?.result?.items}
         users={userItems?.result?.items}
        membership={membershipItems?.result?.items}
        handleInnerFormChange={handleInnerFormChange}
        selectedMembershipMemberMappings={selectedMembershipMemberMappings}
         back={back}
         handleFormSubmit={handleFormSubmit}
         />  
    }
    
          </>
    )
    
    }
   
    export default ManagementMembershipMemberMapping;